package com.dotdrives.config

import kotlin.String

internal object BuildKonfig {
  public val SUPABASE_URL: String = "https://zxhaxyjtqyumjrlyccbb.supabase.co"

  public val SUPABASE_PUBLISHABLE_KEY: String = "sb_publishable_AQv1OeJGGr05NXR3zoGpZA_heP3TCK0"
}
